<ion-content>
  <ion-grid class="no-padding">
    <ion-row class="no-padding">
      <ion-col
        size="12"
        size-md="6"
        style="
          background: var(--ion-item-background);
          padding: 10px;
          border-right: 1px solid var(--ion-subtle-border-color);
        "
      >
        <ion-card-header class="flex-space-between" *ngIf="widget">
          <div style="width: 100%">
            <ion-input
              [(ngModel)]="widget.name"
              class="input-field big-title-input"
              placeholder="Name your in-app chat widget (ex: 'Website')"
              autocapitalize="sentences"
              *ngIf="!widget?.id"
            >
            </ion-input>
          </div>
        </ion-card-header>
        <ion-card-content>
          <ion-grid class="no-padding" style="margin-bottom: 25px">
            <ion-row class="no-padding">
              <ion-col
                size="6"
                class="no-padding"
                [hidden]="widget?.id && widget.isFullPageView"
              >
                <ion-card
                  class="depthButton select-outline mode-toggle"
                  [ngClass]="{ 'mode-toggle-selected': !widget.isFullPageView }"
                  (click)="widget.isFullPageView = false"
                  [disabled]="widget?.id"
                >
                  <ion-icon name="chatbubble-outline"></ion-icon>
                  In-app Chat
                  <br />
                  <span style="font-weight: 400"
                    >Embed a chat bubble into your site</span
                  >
                </ion-card>
              </ion-col>
              <ion-col
                size="6"
                class="no-padding"
                [hidden]="widget?.id && !widget.isFullPageView"
              >
                <ion-card
                  class="depthButton select-outline mode-toggle"
                  [ngClass]="{ 'mode-toggle-selected': widget.isFullPageView }"
                  (click)="widget.isFullPageView = true"
                  [disabled]="widget?.id"
                >
                  <ion-icon name="desktop-outline"></ion-icon>
                  Customer Portal
                  <br />
                  <span style="font-weight: 400"
                    >A full-page view of tickets</span
                  >
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>

          <div class="subtitle">Welcome heading</div>
          <ion-input
            placeholder="Ex: Hi there!"
            [(ngModel)]="widget.title"
            class="input-field"
            style="margin: 0"
          ></ion-input>

          <div class="subtitle" style="margin-top: 15px">Welcome tagline</div>
          <ion-input
            placeholder="Ex: Ask us anything, or share some feedback"
            [(ngModel)]="widget.tagline"
            class="input-field"
            style="margin: 0"
          ></ion-input>

          <div class="subtitle" style="margin-top: 15px">
            Typical reply time
          </div>
          <ion-select
            interface="popover"
            [(ngModel)]="widget.replyTime"
            class="input-field"
            style="margin: 0"
          >
            <ion-select-option value="in_a_few_minutes"
              >In a few minutes</ion-select-option
            >
            <ion-select-option value="in_a_few_hours"
              >In a few hours</ion-select-option
            >
            <ion-select-option value="in_a_day">In a day</ion-select-option>
          </ion-select>

          <div [hidden]="widget.isFullPageView">
            <div class="subtitle" style="margin-top: 15px">Bubble position</div>
            <ion-select
              interface="popover"
              [(ngModel)]="widget.bubblePosition"
              class="input-field"
              style="margin: 0"
            >
              <ion-select-option value="right">Right</ion-select-option>
              <ion-select-option value="left">Left</ion-select-option>
            </ion-select>

            <div class="subtitle" style="margin-top: 15px">Bubble style</div>
            <ion-select
              interface="popover"
              [(ngModel)]="widget.bubbleStyle"
              class="input-field"
              style="margin: 0"
            >
              <ion-select-option value="standard">Standard</ion-select-option>
              <ion-select-option value="expanded">Expanded</ion-select-option>
            </ion-select>
          </div>

          <div class="subtitle" style="margin-top: 15px">Widget color</div>
          <input
            [(colorPicker)]="widget.color"
            [style.background]="widget.color"
            [value]="widget.color"
            [cpPosition]="'bottom-left'"
            [cpOutputFormat]="'hex'"
          />

          <!-- We don't handle "auto" yet so we're disabling this until we do -->
          <!-- <div class="subtitle" style="margin-top: 15px">Dark mode</div>
              <ion-select interface="popover" [(ngModel)]="widget.darkMode" class="input-field" style="margin: 0">
                <ion-select-option value="light">Light</ion-select-option>
                <ion-select-option value="dark">Dark</ion-select-option>
                <ion-select-option value="auto">Auto-detect</ion-select-option>
              </ion-select> -->

          <div class="subtitle" style="margin-top: 15px">
            Enable ticket type selection
          </div>
          <ion-select
            interface="popover"
            [(ngModel)]="widget.ticketTypesEnabled"
            class="input-field"
            style="margin: 0"
          >
            <ion-select-option [value]="false">Disabled</ion-select-option>
            <ion-select-option [value]="true">Enabled</ion-select-option>
          </ion-select>
          <p>
            Require users to select a ticket type and fill out required fields
            before submitting a ticket. Learn more about
            <a
              href="https://docs.unthread.io/conversations/ticket-types"
              target="_blank"
              >Ticket Types</a
            >
          </p>
        </ion-card-content>

        <ion-card-title class="card-title border-top">
          <h3>Post to Slack Channel</h3>
          <div class="subtitle">
            Select the internal channel where new conversations will be posted
          </div>
        </ion-card-title>
        <ion-card-content>
          <app-channel-selector
            [channel]="widget.slackChannel"
            (channelDidChange)="onWidgetChannelChanged($event)"
            [defaultInternalOnly]="true"
          ></app-channel-selector>
        </ion-card-content>

        <ion-card-title class="card-title border-top">
          <h3>SLA</h3>
          <div class="subtitle">
            Determine how incoming messages are assigned, escalated, and
            triaged.
          </div>
        </ion-card-title>
        <app-support-steps
          [initialSupportSteps]="widget.supportSteps"
          (didChange)="supportStepsDidChange($event)"
          [createdBy]="authService.userId"
          [disabled]="isLoading"
        >
        </app-support-steps>

        <ion-card-title class="card-title border-top">
          <h3>Email Notifications</h3>
          <div class="subtitle">
            Unread in-app chat messages will be emailed to customer
          </div>
        </ion-card-title>
        <ion-card-content>
          <div class="subtitle" style="margin-top: 15px">Send emails from</div>
          <ion-select
            interface="popover"
            [(ngModel)]="widget.linkedInboundEmailRuleId"
            class="input-field"
            style="margin: 0"
            placeholder="Default ({{ authService.subdomain }}@mail.unthread.io)"
          >
            <ion-select-option [value]="null">None</ion-select-option>
            <ion-select-option
              *ngFor="let inboundEmailRule of inboundEmailRules"
              [value]="inboundEmailRule.id"
              >{{ inboundEmailRule.customer?.name }}</ion-select-option
            >
          </ion-select>
        </ion-card-content>

        <ion-card-title class="card-title border-top flex-space-between">
          <h3 style="margin-bottom: 18px" class="list-header">Autoresponder</h3>
        </ion-card-title>

        <app-autoresponder
          [isDefault]="false"
          [initialAutoresponder]="widget.autoresponder"
          (autoresponderDidChange)="autoresponderDidChange($event)"
          [projectId]="project?.id ?? undefined"
        ></app-autoresponder>
      </ion-col>
      <ion-col size="12" size-md="6" class="no-padding">
        <div style="padding: 30px; position: sticky; top: 0">
          <ion-button
            fill="clear"
            color="dark"
            (click)="leftTab = 'preview'"
            [ngClass]="{ 'pill-button-active': leftTab === 'preview' }"
          >
            Preview
          </ion-button>
          <ion-button
            fill="clear"
            color="dark"
            (click)="leftTab = 'code'"
            [ngClass]="{ 'pill-button-active': leftTab === 'code' }"
          >
            Code
          </ion-button>
          <div [hidden]="leftTab !== 'code'">
            <div *ngIf="widget && widget.id">
              <h5>Embed within the <code>&lt;head&gt;</code> tag:</h5>
              <div class="hljs javascript code-background">
                <a
                  ngxTippy
                  data-tippy-content="Copy to clipboard"
                  class="clipboard-icon"
                  (click)="copyToClipboard(widget)"
                >
                  <ion-icon name="copy-outline"></ion-icon>
                </a>
                <pre><code [innerHTML]="getCodeHtml(widget)"></code></pre>
              </div>
              <div *ngIf="widget.isFullPageView">
                <h5>Embed iFrame</h5>
                <div class="hljs javascript code-background">
                  <a
                    ngxTippy
                    data-tippy-content="Copy to clipboard"
                    class="clipboard-icon"
                    (click)="copyIFrameHtml()"
                  >
                    <ion-icon name="copy-outline"></ion-icon>
                  </a>
                  <pre><code [innerHTML]="getIFrameHtml()"></code></pre>
                </div>
              </div>
              <h5>Identity verification secret</h5>
              <div class="flexed">
                <ion-input
                  [disabled]="true"
                  [(ngModel)]="widget.verificationSecret"
                  class="input-field"
                  [type]="verificationSecretShown ? 'text' : 'password'"
                  style="margin: 0"
                ></ion-input>
                <ion-button fill="clear" (click)="toggleVerificationSecret()">{{
                  verificationSecretShown ? "Hide" : "Show"
                }}</ion-button>
              </div>
              <div *ngIf="!widget?.isFullPageView">
                <h5>Show the widget on your website</h5>
                <pre><code>window.$unthread.inAppChat("start")</code></pre>
                <a
                  href="https://docs.unthread.io/in-app/chat-widget"
                  target="_blank"
                  >Follow the steps in our docs to show the widget on your page
                  <ion-icon name="open-outline"></ion-icon
                ></a>
              </div>
            </div>
            <div
              style="padding: 30px 15px; text-align: center; color: #666"
              *ngIf="!widget?.id"
            >
              Save changes to generate code snippet
            </div>
          </div>
          <div
            class="preview"
            style="margin-top: 20px"
            [hidden]="leftTab !== 'preview'"
          >
            <ion-card *ngIf="widget.isFullPageView" style="text-align: center">
              <ion-card-content>
                <a
                  href="https://docs.unthread.io/in-app/customer-portal"
                  target="_blank"
                  >View docs about the customer portal
                  <ion-icon name="open-outline"></ion-icon
                ></a>
              </ion-card-content>
            </ion-card>
            <div
              style="
                border-radius: 12px;
                box-shadow: 0px 3px 16px -8px #666;
                max-width: 420px;
                margin-left: auto;
                margin-right: auto;
                color: black;
              "
              *ngIf="!widget.isFullPageView"
            >
              <div
                style="padding: 15px; border-radius: 12px 12px 0 0"
                [ngClass]="{
                  'preview-black': isDarkModePreview,
                  'preview-white': !isDarkModePreview
                }"
              >
                <h2>
                  {{ widget.title || "Title" }}
                </h2>
                <p style="margin: 0">
                  {{ widget.tagline || "Tagline" }}
                </p>
              </div>
              <div
                style="
                  padding: 300px 15px 15px 15px;
                  border-radius: 0 0 12px 12px;
                "
                [ngClass]="{
                  'preview-dark': isDarkModePreview,
                  'preview-white': !isDarkModePreview
                }"
              >
                <p *ngIf="widget.replyTime === 'in_a_few_minutes'">
                  Typically replies in a few minutes
                </p>
                <p *ngIf="widget.replyTime === 'in_a_few_hours'">
                  Typically replies in a few hours
                </p>
                <p *ngIf="widget.replyTime === 'in_a_day'">
                  Typically replies in a day
                </p>
                <ion-button
                  size="block"
                  class="btn-large"
                  [ngStyle]="{ '--background': widget.color }"
                  >Start conversation</ion-button
                >
              </div>
            </div>

            <div
              style="margin-top: 21px; display: flex; justify-content: center"
            >
              <div
                class="round-pill-tab round-pill-tab-left"
                [ngClass]="{
                  'round-pill-tab-active': !isDarkModePreview
                }"
                (click)="isDarkModePreview = false"
              >
                Light
              </div>
              <div
                class="round-pill-tab round-pill-tab-right"
                [ngClass]="{
                  'round-pill-tab-active': isDarkModePreview
                }"
                (click)="isDarkModePreview = true"
              >
                Dark
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <div class="flex-space-between" style="padding: 18px">
    <div class="flexed-align-center">
      <ion-button
        fill="clear"
        color="dark"
        (click)="selectProject()"
        class="button-dark-border"
        *ngIf="!widget?.id && !hideProject"
      >
        <ion-icon
          [name]="project?.name ? 'custom-project' : 'custom-project-outline'"
          class="padded-icon button-icon"
        ></ion-icon>
        {{
          project?.name ? project.name : project?.id ?? "Select a project..."
        }}
        <ion-icon
          name="chevron-down-outline"
          class="icon-padded-left button-icon"
        ></ion-icon>
      </ion-button>
      <ion-button
        (click)="save()"
        class="save-button"
        [disabled]="!featureEnabled || isLoading"
      >
        {{ widget?.id ? "Save changes" : "Save" }}
        <ion-spinner
          name="crescent"
          style="margin-left: 5px"
          *ngIf="isLoading"
        ></ion-spinner>
      </ion-button>
    </div>
    <div class="flexed-align-center">
      <ion-button fill="clear" (click)="dismiss()"> Cancel </ion-button>
      <ion-button
        color="danger"
        fill="clear"
        (click)="delete(widget)"
        *ngIf="widget?.id"
        [disabled]="isLoading"
      >
        Disable
      </ion-button>
    </div>
  </div>
</ion-footer>
